var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 235,
    viewBox: "0 0 56 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.423 26.027C54.3439 11.4683 42.4919 0 28.0301 0C13.5683 0 1.71633 11.4683 0.637229 26.027H0.557129V203.878H0.637229C0.584216 204.594 0.557129 205.317 0.557129 206.047C0.557129 221.619 12.8572 234.243 28.0301 234.243C43.203 234.243 55.5031 221.619 55.5031 206.047C55.5031 205.317 55.476 204.594 55.423 203.878H55.5031V26.027H55.423Z",
    fill: "#F39100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa4);
export default __webpack_public_path__ + "static/media/IA_4.4ba0c974836684f698764393500331be.svg";
export { ForwardRef as ReactComponent };